module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ef-Fb.2c1e22ee.png";